module.exports = __webpack_public_path__ + "assets/img/plan4-2.bb068926.png";